export const defaultWalletDataQueryParams: WOM.TransactionQueryRequest = {
    pageIndex: 0,
    limit: 10,
    returnQueryCount: true
};
